import { CriteriaState } from './types';

/**
 * Generic field update helper to reduce setState boilerplate
 */
export function createFieldUpdater<T extends keyof CriteriaState>(
  setState: React.Dispatch<React.SetStateAction<CriteriaState>>,
  field: T
) {
  return (value: CriteriaState[T]) => {
    setState((s) => ({
      ...s,
      [field]: value,
    }));
  };
}

/**
 * Option formatting utilities
 */
export const formatOptions = {
  fromObjects: <T extends { id: number | string; name?: string; title?: string }>(
    items: T[],
    labelField: keyof T = 'name'
  ) =>
    items.map((item) => ({
      label: String(item[labelField] || `Item ${item.id}`),
      value: item.id.toString(),
    })),

  fromArray: (items: string[]) =>
    items.map((item) => ({
      label: item,
      value: item,
    })),

  fromNumbers: (start: number, end: number) =>
    Array.from({ length: end - start + 1 }, (_, i) => {
      const value = start + i;
      return {
        label: value.toString(),
        value: value.toString(),
      };
    }),
};
